import type ViewAccessor from '@123/druid/dist/Framework/View/ViewAccessor';
import type DelegateEvent from '@123/druid/dist/Types/DelegateEvent';
import type Scrollable from '@Service/Scrollable/Scrollable';

export default class AnimateToAnchorHandler {
    constructor(
        private accessor: ViewAccessor,
        private readonly scroller: Scrollable,
    ) {}

    public attach(): void {
        this.accessor.onMounted(() => {
            const element = this.accessor.getElement();
            element.addDelegateListener('click', '[data-role~=animate-to-anchor]', (event: DelegateEvent) => {
                const id = event.delegateTarget.attributeMap().getString('href').replace('#', '');
                const scrollTarget: HTMLElement | null = element.querySelector(`[id='${id}']`);

                if (!scrollTarget) {
                    return;
                }

                event.event.preventDefault();
                this.scroller.scrollElement(scrollTarget, {block: 'start', behavior: 'smooth'});
            });
        });
    }
}
